import { render, staticRenderFns } from "./DetailCabinStockTable.vue?vue&type=template&id=4e6d24fe&scoped=true&"
import script from "./DetailCabinStockTable.vue?vue&type=script&lang=js&"
export * from "./DetailCabinStockTable.vue?vue&type=script&lang=js&"
import style0 from "./DetailCabinStockTable.vue?vue&type=style&index=0&id=4e6d24fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6d24fe",
  null
  
)

export default component.exports